/**
 * This is the primary entry point for the SG Messaging Client library (sgmc.min.js).  Re-export
 * any symbols here, and set globals via self[].
 * 
 * This library is ORTHOGONAL to the Viewer runtime build.  Please do not use both at once.
 */

import { SGMessagingClient, SGMessagingClientF } from '@sg/PortingSpace/SGMessagingClientPure';

export * from '@sg/PortingSpace/SGMessagingClientPure';

self["SGMessagingClient"] = SGMessagingClient;
self["SGMessagingClientF"] = SGMessagingClientF;

self["SGMCVersion"] = "2.0.24";
